module.exports = __webpack_public_path__ + "static/pkrupar-9276704321386176f0146b90fa666256.jpg";